/**
 * A Date as YYYY-MM-DD in the browser's own timezone.
 *
 * `date.toISOString().split('T')[0]` reads the date in UTC, not local time. In
 * India (UTC+05:30) that names yesterday between 00:00 and 05:30, so default
 * dates on forms (invoice date, payment date, joining date, "as on" dates) were
 * pre-filled a day early during those hours. Worse, a Date built at local
 * midnight — `new Date(2026, 8, 19)` — is 18:30 UTC the previous day, so
 * converting it that way was one day off at every hour.
 *
 * This reads the local calendar fields instead, which is what a date input and a
 * user both mean by "the date".
 *
 * @param {Date|string|number} [date] defaults to now
 * @returns {string} YYYY-MM-DD, or '' for an invalid date
 */
export const localDateString = (date = new Date()) => {
    const d = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
